import { SET_LOYALTY_CUSTOMER_ENROLMENT_PENDING } from 'actions/actionConstants'
import type { AppAction } from 'actions/types/ActionTypes'

/**
 * Marks that a logged-out customer clicked a Société enrol CTA and is signing in, so sign-in
 * auto-enrolment (autoEnrolLoyaltyAccount) leaves the enrolment to that CTA and they're recorded
 * as CUSTOMER. Set by AccountAccessModal while it's open with `skipLoyaltyAutoEnrolment`.
 */
function setLoyaltyCustomerEnrolmentPending(isCustomerEnrolmentPending: boolean): AppAction {
  return {
    type: SET_LOYALTY_CUSTOMER_ENROLMENT_PENDING,
    isCustomerEnrolmentPending,
  }
}

export default setLoyaltyCustomerEnrolmentPending
